import React, { useState } from 'react';
import styles from '../styles/footer.module.css'
import WhiteLetters from '../images/WhiteLetters.png'

const contributors = [
    "Charles Luo",
    "Benson Lee",
    "Shreyas Deshpande",
    "Davis Kim",
    "Terence Mui",
    "Jared Nagata",
    "Nanma Pillai",
    "Nuha Rahman",
    "Brandon Ta",
    "Catherine Truong",
];

const Footer = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <div className={styles.footer}>
                <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.3/font/bootstrap-icons.min.css"></link>
                <div className={styles.contents}>
                    <div className={styles.buttons}>
                        <a href="https://thetatau.org" className={styles.tooltip} data-tooltip="National Website">
                            <img className={styles.letters} src={WhiteLetters} alt="Theta Tau Letters"/>
                        </a>
                        <a className={`${styles.insta} ${styles.tooltip}`} href='https://www.instagram.com/thetatauucr/' data-tooltip="Instagram">
                            <i className="bi bi-instagram"></i>
                        </a>
                        <a className={`${styles.mail} ${styles.tooltip}`} href="mailto:thetatauucr@gmail.com" data-tooltip="Email Us">
                            <i className="bi bi-envelope"></i>
                        </a>
                    </div>
                    <p className={styles.credits} onClick={() => setOpen(true)}>Website Credits</p>
                </div>
            </div>

            {open && (
                <div className={styles.overlay} onClick={() => setOpen(false)}>
                    <div className={styles.modal} onClick={e => e.stopPropagation()}>
                        <div className={styles.modalHeader}>
                            <span className={styles.modalEyebrow}>Sigma Delta Chapter</span>
                            <h2 className={styles.modalTitle}>Website Credits</h2>
                            <button className={styles.closeBtn} onClick={() => setOpen(false)} aria-label="Close">
                                <i className="bi bi-x-lg"></i>
                            </button>
                        </div>
                        <div className={styles.modalRule}></div>
                        <ul className={styles.contributorList}>
                            {contributors.map(name => (
                                <li key={name} className={styles.contributorItem}>{name}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
        </>
    );
};

export default Footer;
